module.exports = __webpack_public_path__ + "img/img17.df6eaaca.svg";